<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates3">
<p class="centerImage"><img alt="images" id="plate3" src="images/plate3.jpg"/></p>
<p class="caption">All kitted out and somewhere to go. From the left, Williams, McLean, Thorogood, Kerry, RWF.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates3.vue?0fd73d54